(() => {
  const ui = document.querySelector('[data-th-favourites-ui]');
  if (!ui) return;
  const labels = JSON.parse(ui.querySelector('[data-th-favourites-labels]').textContent);
  const key = 'tamzey-favourites-v1';
  const panel = ui.querySelector('[data-th-favourites-dialog]');
  const menuDialog = ui.querySelector('[data-th-mobile-menu-dialog]');
  const grid = ui.querySelector('[data-th-favourites-grid]');
  const notice = ui.querySelector('[data-th-favourites-notice]');
  const status = ui.querySelector('[data-th-favourites-status]');
  const root = ui.dataset.root.replace(/\/?$/, '/');
  let saved = [];
  let opener;
  let oldOverflow = '';
  let renderVersion = 0;
  let storageWorks = true;
  const cache = new Map();
  const cardRevealObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 }) : null;
  const heart = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M20.8 4.6a5.3 5.3 0 0 0-7.5 0L12 5.9l-1.3-1.3a5.3 5.3 0 0 0-7.5 7.5L12 21l8.8-8.9a5.3 5.3 0 0 0 0-7.5Z"/></svg>';
  function readSaved() {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(x => typeof x === 'string' && /^[a-z0-9-]+$/.test(x)))].slice(0, 100) : [];
    } catch (_) { storageWorks = false; return []; }
  }
  saved = readSaved();
  function productHandle(url) {
    try { return new URL(url, location.origin).pathname.match(/\/products\/([a-z0-9-]+)/)?.[1] || null; } catch (_) { return null; }
  }
  function updateHearts() {
    document.querySelectorAll('[data-th-save-product]').forEach(button => {
      const active = saved.includes(button.dataset.thSaveProduct);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? labels.remove : labels.save);
      button.title = active ? labels.remove : labels.save;
    });
    document.querySelectorAll('[data-th-favourites-count]').forEach(count => { count.textContent = saved.length; count.hidden = saved.length === 0; });
    notice.textContent = storageWorks ? labels.note : labels.storage;
  }
  function toggle(handle) {
    if (saved.includes(handle)) { saved = saved.filter(x => x !== handle); status.textContent = labels.removed; }
    else { if (saved.length >= 100) { status.textContent = labels.limit; return; } saved.push(handle); status.textContent = labels.added; }
    try { localStorage.setItem(key, JSON.stringify(saved)); } catch (_) { storageWorks = false; }
    updateHearts();
    if (panel.open) renderList();
  }
  function makeHeart(handle) {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'th-save-product'; button.dataset.thSaveProduct = handle; button.innerHTML = heart;
    return button;
  }
  function decorateCards() {
    document.querySelectorAll('a.th-edit__product, a.th-gallery-v3__product, a.th-object-feature').forEach(link => {
      const handle = productHandle(link.href);
      if (!handle) return;
      const host = document.createElement('div');
      Array.from(link.attributes).forEach(attr => { if (!['href', 'aria-label', 'target', 'rel'].includes(attr.name)) host.setAttribute(attr.name, attr.value); });
      host.classList.add('th-fav-host');
      const content = document.createElement('a');
      content.href = link.href; content.className = 'th-fav-content';
      if (link.getAttribute('aria-label')) content.setAttribute('aria-label', link.getAttribute('aria-label'));
      while (link.firstChild) content.append(link.firstChild);
      host.append(content, makeHeart(handle)); link.replaceWith(host);
      if (host.classList.contains('th-reveal') && !host.classList.contains('is-visible')) {
        if (cardRevealObserver && !window.Shopify?.designMode) cardRevealObserver.observe(host);
        else host.classList.add('is-visible');
      }
    });
    document.querySelectorAll('.product-card-wrapper').forEach(card => {
      if (card.querySelector('[data-th-save-product]')) return;
      const link = card.querySelector('a[href*="/products/"]');
      const handle = link && productHandle(link.href);
      if (!handle) return;
      card.classList.add('th-fav-host'); card.append(makeHeart(handle));
    });
    const detail = document.querySelector('.product__info-container');
    const handle = productHandle(location.href);
    if (detail && handle && !detail.querySelector('[data-th-save-product]')) {
      const button = makeHeart(handle); button.classList.add('th-save-product--detail');
      const text = document.createElement('span'); text.textContent = labels.title; button.append(text); detail.append(button);
    }
    updateHearts();
  }
  function closeDialog(dialog) { if (dialog.open) dialog.close(); }
  function openDialog(dialog, trigger) {
    if (document.querySelector('dialog[open]')) return;
    const headerMenu = document.querySelector('.th-header-menu'); if (headerMenu) headerMenu.open = false;
    opener = trigger; oldOverflow = document.body.style.overflow;
    dialog.showModal(); document.body.style.overflow = 'hidden';
  }
  [panel, menuDialog].forEach(dialog => {
    dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(dialog); });
    dialog.addEventListener('close', () => { document.body.style.overflow = oldOverflow; if (opener?.isConnected) opener.focus(); });
  });
  function textElement(tag, text, className) { const element = document.createElement(tag); element.textContent = text; if (className) element.className = className; return element; }
  async function getProduct(handle) {
    if (!cache.has(handle)) cache.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { signal: AbortSignal.timeout(12000) }).then(r => { if (!r.ok) throw new Error('unavailable'); return r.json(); }).catch(error => { cache.delete(handle); throw error; }));
    return cache.get(handle);
  }
  async function renderList() {
    const version = ++renderVersion;
    grid.replaceChildren();
    if (!saved.length) { grid.append(textElement('p', labels.empty, 'th-favourites-empty')); return; }
    grid.setAttribute('aria-busy', 'true');
    const handles = [...saved];
    const slots = handles.map(handle => { const slot = document.createElement('article'); slot.className = 'th-favourites-card'; slot.append(textElement('p', labels.loading)); grid.append(slot); return { handle, slot }; });
    let next = 0;
    async function worker() {
      while (next < slots.length) {
        const { handle, slot } = slots[next++];
        let product;
        try { product = await getProduct(handle); } catch (_) {}
        if (version !== renderVersion) return;
        slot.replaceChildren();
        if (product) {
          const link = document.createElement('a'); link.href = root + 'products/' + encodeURIComponent(handle);
          if (product.featured_image) { const image = document.createElement('img'); image.src = product.featured_image; image.alt = product.title; image.loading = 'lazy'; image.width = 360; image.height = 360; link.append(image); }
          link.append(textElement('h3', product.title));
          const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: ui.dataset.currency }).format(product.price / 100);
          link.append(textElement('p', (product.price_varies ? labels.from + ' ' : '') + money));
          if (!product.available) link.append(textElement('p', labels.soldOut, 'th-favourites-unavailable'));
          slot.append(link);
        } else slot.append(textElement('p', labels.unavailable));
        const remove = textElement('button', labels.removeShort, 'th-favourites-remove'); remove.type = 'button'; remove.dataset.thSaveProduct = handle; remove.setAttribute('aria-label', labels.remove + (product ? ': ' + product.title : '')); slot.append(remove);
      }
    }
    await Promise.all(Array.from({ length: Math.min(6, slots.length) }, worker));
    if (version === renderVersion) grid.removeAttribute('aria-busy');
  }
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-th-save-product]');
    if (save) { event.preventDefault(); event.stopPropagation(); toggle(save.dataset.thSaveProduct); return; }
    const open = event.target.closest('[data-th-open-favourites]');
    if (open) { event.preventDefault(); openDialog(panel, open); if (panel.open) renderList(); return; }
    const menu = event.target.closest('[data-th-open-mobile-menu]');
    if (menu) {
      const original = document.querySelector('.th-header-menu__panel');
      const target = menuDialog.querySelector('[data-th-mobile-menu-content]');
      if (original) { const clone = original.cloneNode(true); clone.removeAttribute('id'); clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id')); clone.querySelectorAll('details').forEach(el => { el.open = false; el.removeAttribute('name'); }); target.replaceChildren(clone); }
      openDialog(menuDialog, menu); return;
    }
    const close = event.target.closest('[data-th-close-dialog]'); if (close) closeDialog(close.closest('dialog'));
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { saved = readSaved(); updateHearts(); if (panel.open) renderList(); } });
  let scheduled = false;
  const main = document.querySelector('#MainContent');
  if (main) new MutationObserver(records => { if (!records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && !node.matches('.th-save-product')))) return; if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; decorateCards(); }); } }).observe(main, { childList: true, subtree: true });
  const mobile = window.matchMedia('(max-width: 989px)');
  if (window.visualViewport) { const initialHeight = window.visualViewport.height; window.visualViewport.addEventListener('resize', () => { ui.querySelector('.th-mobile-bar').hidden = mobile.matches && window.visualViewport.height < initialHeight * .7 && /INPUT|TEXTAREA/.test(document.activeElement?.tagName || ''); }); }
  decorateCards();
})();
